export default {"src":"/_next/static/media/icon-call.202a98a8.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};